A candidate's preferences in the location of a position.
